<template>
  <PmwAlertModal
    v-model="modalShow"
    title="Inativar regra"
    icon="pmw-trash-can"
    iconColor="red-80"
    cancelButtonColor="grey-100"
    confirmButtonColor="error-100"
    @alert-modal-cancel="$emit('close', $event)"
    @alert-modal-confirm="$emit('disable', $event)"
  >
    <template #text>
      Após inativar essa regra, ela não ficará mais disponível. Você tem certeza
      que quer fazer isso?
    </template>
  </PmwAlertModal>
</template>

<script>
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'

export default {
  name: 'DeleteRateModel',

  components: {
    PmwAlertModal
  },

  props: {
    showDeleteModal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      modalShow: false
    }
  },

  watch: {
    showDeleteModal(newVal) {
      this.modalShow = newVal
    }
  }
}
</script>
